<div class="row account-overview-header">
  <div class="col-xs-4 col-sm-5 col-md-7 flu-reservation-title">
    <h3 class="reservation-details">
      {{ "accountOverview.FluReservations.title" | cxTranslate }}
    </h3>
  </div>
</div>

<section class="col-12 col-xs-12 col-sm-7 col-md-12">
  <section class="row line-bottom mobileDisplayBlock">
    @for (season of seasonsList; track season) {
      <section class="col-4 col-md-4 mini-card">
        <section class="three-columns-line">
          <img [src]="'/icons/'+baseSiteId+'/calendar.svg'" alt="calendar" />
          <h3>
            @if (season?.fluResevartion) {
              <span>Reservation &nbsp; {{season.fluOrderNumber}}</span>
            }
            @if (!season?.fluResevartion) {
              <span>Influenza season is open</span>
            }
          </h3>
          <p>
            @if (season?.fluResevartion) {
              <span>View details for your {{season?.code}} reservations.</span>
            }
            @if (!season?.fluResevartion) {
              <span [innerHTML]="season.alertMessage"></span>
            }
          </p>
          <button type="button" class="btn-primary w-100" (click)="onInfRedirect()">
            {{ season.fluResevartion ? viewBtnText : createBtnText }}
          </button>
        </section>
      </section>
    }
    <section class="col-lg-4 col-md-4 col-sm-12">
      @if (displayActiveSeasons) {
        <section class="three-columns-line">
          <img [src]="'/icons/'+baseSiteId+'/calendar.svg'" alt="calendar" />
          <h3>
            Influenza vaccine locator
          </h3>
          <p>Enroll your location in the new Influenza vaccine locator and help patients find you.</p>
          <button type="button" class="btn-primary w-100" (click)="onManageSetting()">
            Manage settings
          </button>
        </section>
      }
    </section>
  </section>
</section>
